// Gentle Layer-1 reflection prompts shown right after a memory is saved.
export const CATEGORY_PROMPTS = {
  "Love & Family": "What did loving these people teach you about yourself?",
  "Education & Growth": "Looking back, what were you most proud of learning here?",
  "Work & Career": "What did this chapter reveal about what matters to you?",
  "Home & Living": "What made this place feel like home?",
  "Travel & Relocations": "What did stepping into the unknown teach you?",
  "Health & Body": "What did your body and spirit show you about your own strength?",
  "Loss & Difficult Times": "How did you find your way through — and what stayed with you?",
  "Social & Community": "Who or what made you feel you belonged?",
  "Defining Moments": "How did this moment change the direction of your life?",
  "Joyful Moments": "What small thing about this still makes you smile?",
  "Challenging Moments": "What did you discover you were capable of?",
  "Growth & Learning Moments": "What do you understand now that you didn't before?",
  "Other Meaningful Moment": "Why does this ordinary moment still matter to you?",
};

export const DEFAULT_PROMPT = "Looking back, what does this moment mean to you now?";

export function promptFor(category) {
  return (category && CATEGORY_PROMPTS[category]) || DEFAULT_PROMPT;
}
